import { AxiosResponse } from 'axios';
import { MeasureUnitApiResponse, MeasureUnitUI } from 'types/interfaces/MeasureUnitUI';

import { api } from '../../http';
import {
  BaseFilter,
  PageRequest,
  PageResponse,
} from '../../types/interfaces';

import { ApiResponse } from './interfaces';

export const MeasureUnitService = {
  getMeasureUnit(
    params: PageRequest & {
      sortBy?: string;
      sortDirection?: string;
      parsedFilters?: BaseFilter[];
      fillers?: string;
    }
  ): Promise<AxiosResponse<ApiResponse<PageResponse<MeasureUnitUI>>>> {
    const searchParams = new URLSearchParams();
    Object.keys(params).forEach((key) => {
      if (params[key]) {
        searchParams.append(key, String(params[key]));
      }
    });

    return api.get<ApiResponse<PageResponse<MeasureUnitUI>>>('MeasureUnit', {
      params: searchParams
    });
  },

  updateMeasureUnit(
    id: number, 
    MeasureUnit: MeasureUnitUI
  ): Promise<AxiosResponse<ApiResponse<MeasureUnitUI>>> {
    return api.put<ApiResponse<MeasureUnitUI>>(
      `MeasureUnit/${id}`,
      MeasureUnit
    );
  },

  deleteMeasureUnit(id: number): Promise<AxiosResponse<ApiResponse<null>>> {
    return api.delete<ApiResponse<null>>(`MeasureUnit/${id}`); 
  },

  createMeasureUnit(
    MeasureUnit: MeasureUnitUI
  ): Promise<AxiosResponse<ApiResponse<MeasureUnitUI>>> {
    return api.post<ApiResponse<MeasureUnitUI>>('MeasureUnit', MeasureUnit);
  }, 
  getMeasureUnitForSelection(): Promise<AxiosResponse<MeasureUnitApiResponse>> {
    return api.get<MeasureUnitApiResponse>('MeasureUnit', {
      params: { ForSelection: 'true' }
    });
  }
};
